/* eslint-disable no-use-before-define */
import React, { Component } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import "../styles/Autocomplete.css";
import HelperText from './common/errorHelperText';
import PropTypes from 'prop-types';
const _ = require('lodash');

class Autocomp extends Component {
  constructor(props) {
    super(props);
    this.state = { value: props.value ?? /* istanbul ignore next */ [], inputValue: "", errormsg: props.errormsg ?? ''};
  }

  componentDidUpdate(prevProps) {
    if (prevProps.errormsg !== this.props.errormsg) {
      this.setState({ errormsg: this.props.errormsg ?? '' });
    }
    const numericSort = (a, b) => Number(a) - Number(b);
    if (!_.isEqual(
      [...this.props.value].sort(numericSort),
      [...this.state.value].sort(numericSort)
    )) {
      this.setState({ value: this.props.value });
    }
  }

  setValue(val) {
    const { validator } = this.props;
    let accepted = [...new Set(val)];
    let rejected = [];

    if (validator) {
      const seen = new Set();
      accepted = [];
      val.forEach(token => {
        const t = token.trim();
        if (!t) return;
        if (validator(t)) {
          if (!seen.has(t)) {
            seen.add(t);
            accepted.push(t);
          }
        } else {
          rejected.push(t);
        }
      });
    }

    const errormsg = rejected.length > 0
      ? `Non-valid values ignored: ${rejected.join(', ')}`
      : "";

    this.setState({ value: accepted, errormsg }, () => {
      this.props.newAAutoVal(this.state.value);
      const scrollElement = document.querySelector("#autocomp .MuiInputBase-root");
      if (scrollElement)
        scrollElement.scrollTop = scrollElement.scrollHeight;
    });
  }

  setInputValue(val) {
    this.setState({ inputValue: val });
  }

  _handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      const typed = e.target.value.trim();
      if (typed) {
        const val = this.state.value.map(data => data.toString())
          .concat(typed)
          .map(x => x.trim())
          .filter(x => x);
        this.setValue(val);
        this.setInputValue('');
      }
    }
  };

  render() {
    return (
      <div>
        <Autocomplete
          disableClearable={true}
          multiple
          freeSolo
          autoSelect={true}
          id="renderInput"
          options={[]}
          value={this.state.value}
          inputValue={this.state.inputValue}
          onChange={(event, newValue) => {
            this.setValue(newValue);
          }}
          onKeyDown={this._handleKeyDown}
          onInputChange={(event, newInputValue) => {
            const options = newInputValue.split(/\r\n|\r|\n|,|\t|\s/);

            if (options.length > 1) {
              this.setValue(
                this.state.value.map(data => data.toString())
                  .concat(options)
                  .map(x => x.trim())
                  .filter(x => x)
              );
              this.setInputValue('');
            } else {
              this.setInputValue(newInputValue);
            }
          }}
          renderInput={params => (
            <TextField
              error={this.state.errormsg.length > 0}
              id="outlined-error-helper-text"
              helperText={this.state.errormsg.length > 0 && <HelperText text={this.state.errormsg} />}
              {...params}
              InputProps={{ ...params.InputProps, disableUnderline: true, className: "autoCompleteCss"}}
              multiline
              variant="standard"
              maxRows={Infinity}
              minRows="1"
            />
          )}
        />
      </div>
    );
  }
}

Autocomp.propTypes = {
  value: PropTypes.array,
  errormsg: PropTypes.string,
  newAAutoVal: PropTypes.func.isRequired,
  validator: PropTypes.func
};

export default Autocomp;
